export default "__VITE_ASSET__5235a1cc__"